import http from './http';

import { createLogger } from '../utils/logger';

const logger = createLogger('cellphoneProvider');
export interface CellphoneProviderInfoRec {
  id: string;
  userId: string;
  carrierName?: string;
  userPhoneNumber?: string;
  accountNumber?: string;
  carrierPhone?: string;
  accountOwner?: string;
  phonePasscode?: string;
  carrierWebsite?: string;
  carrierPortal?: string;
  notes?: string;
  isLocked?: boolean;
}

class CellphoneProviderInfoService {
  async getAllCellphoneProviderInfo(targetUserId?: string): Promise<CellphoneProviderInfoRec[]> {
    const url = targetUserId
      ? `/api/cellphone-provider-info?targetUserId=${targetUserId}`
      : '/api/cellphone-provider-info';
    const response = await http.get(url);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch cellphone provider information');
    }

    return response.data.data || [];
  }

  async getCellphoneProviderInfo(): Promise<CellphoneProviderInfoRec[]> {
    return this.getAllCellphoneProviderInfo();
  }

  async createCellphoneProviderInfo(data: Partial<CellphoneProviderInfoRec>): Promise<CellphoneProviderInfoRec> {
    const response = await http.post('/api/cellphone-provider-info', data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to save cellphone provider information');
    }

    return response.data.data;
  }

  async updateCellphoneProviderInfo(id: string, data: Partial<CellphoneProviderInfoRec>): Promise<CellphoneProviderInfoRec> {
    const response = await http.patch(`/api/cellphone-provider-info/${id}`, data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to update cellphone provider information');
    }

    return response.data.data;
  }

  async deleteCellphoneProviderInfo(id: string): Promise<void> {
    const response = await http.delete(`/api/cellphone-provider-info/${id}`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to delete cellphone provider information');
    }
  }

  async lockCellphoneProviderInfo(id: string): Promise<void> {
    logger.debug('[Service Debug] Calling lock API for cellphone provider ID:', id);
    const response = await http.post(`/api/cellphone-provider-info/${id}/lock`);
    logger.debug('[Service Debug] Lock API response:', response.data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to lock cellphone provider information');
    }
  }

  async unlockCellphoneProviderInfo(id: string, granteeEmails: string[]): Promise<void> {
    const response = await http.post(`/api/cellphone-provider-info/${id}/unlock`, { granteeEmails });
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to unlock cellphone provider information');
    }
  }

  async getCellphoneProviderAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/cellphone-provider-info/${id}/access-grants`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch access grants');
    }

    return response.data.data || [];
  }
}

export const cellphoneProviderInfoService = new CellphoneProviderInfoService();